import { render, staticRenderFns } from "./AwardPoints.vue?vue&type=template&id=38ec060e&lang=pug"
import script from "./AwardPoints.vue?vue&type=script&lang=js"
export * from "./AwardPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports